import { Injectable } from '@angular/core';
import { AttributionService } from './attribution.service';
import { GethubTrackerService } from './gethub-tracker.service';

@Injectable({
  providedIn: 'root'
})
export class GaEcommerceService {
  constructor(
    private attribution: AttributionService,
    private gethub: GethubTrackerService,
  ) {}

  products = [
      {
          item_id: 1,
          item_name: 'Rent Guarantee',
          policy_type_id: 5,
          quantity: 1
      },
      {

          item_id: 2,
          item_name: 'Renters Insurance',
          policy_type_id: 1,
          quantity: 1
      }
  ];

  getProduct(policyTypeId, additionalInfo = {}) {
      const prod = this.products.find(product => product.policy_type_id === policyTypeId);
      const item = Object.assign(additionalInfo, prod);

      return item;
  }

  formatPrice(price) {
      return price / 100;
  }

  /**
   * Fires the GA4 `purchase` conversion, merging the cross-site attribution params
   * (gc_click_id + campaign) so the sale ties back to the originating getcovered.io click.
   */
  trackPurchase(obj: Record<string, unknown>): void {
      // Native GetHub funnel conversion, parallel to GA and identically
      // isolated: ties the completed sale back to the originating getcovered.io
      // click. Fired at the same success chokepoint GA uses, deduped by the
      // transaction (quote) id, and carries only the join key — never an amount
      // or PII. Runs independently of GA so a missing gtag never suppresses it.
      // The whole block — including reading obj — sits inside its own try so
      // analytics can never throw into the post-purchase path, even on an
      // unexpected null/undefined obj.
      try {
          const transactionId = obj?.['transaction_id'];
          this.gethub.trackPurchaseOnce(
              typeof transactionId === 'string' || typeof transactionId === 'number'
                  ? String(transactionId)
                  : null,
              this.attribution.clickId,
          );
      } catch {
          // swallow — a missed analytics event must not affect a completed sale
      }

      // Analytics runs after the policy is already accepted; it must never throw
      // into the post-purchase callback, so the whole thing is isolated.
      try {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const gtag = (typeof window !== 'undefined') ? (window as any).gtag : undefined;
          if (typeof gtag !== 'function') {
              return;
          }
          gtag('event', 'purchase', { ...obj, ...this.attribution.gaEventParams() });
      } catch {
          // swallow — a missed analytics event must not affect a completed sale
      }
  }
}
